<template>
  <section class="flex flex-col gap-10">
    <section class="grid grid-cols-12 gap-x-6 gap-y-8">
      <span class="col-span-12 font-bold">Dados Pessoais</span>
      <person-form
          :form="form"
          :email-required="true"
          :errors="errors ?? {}"
      ></person-form>
    </section>
    <section class="grid grid-cols-12 gap-x-6 gap-y-8">
      <span class="col-span-12 font-bold">Endereço</span>
      <address-form
          :address="address"
          v-if="!foundPerson"
          :errors="errors ?? {}"
      ></address-form>
    </section>
    <section class="grid grid-cols-12 gap-x-6 gap-y-8">
      <span class="col-span-12 font-bold">Dados Colaboração</span>
      <collaboration-form
          :collaboration="form"
          :errors="errors ?? {}"
      ></collaboration-form>
    </section>
  </section>
  <section class="flex flex-row justify-center gap-6">
    <rpm-button @click="handleCollaborator" label="Salvar"/>
    <rpm-button @click="closeModal" label="Fechar" color="gray"/>
  </section>
</template>

<script>
import {ref, watch} from 'vue'
import AddressForm from '#views/address/form';
import PersonForm from "#views/person/form";
import CollaborationForm from '../form.vue'
import personRepository from "#repositories/personRepository";
import collaboratorRepository from "#repositories/collaboratorRepository";

export default {
  name: 'CreateCollaborator',
  components: {
    AddressForm,
    PersonForm,
    CollaborationForm
  },
  setup(props, {emit}) {
    const form = ref({
      registration_id: null,
      email: '',
      email_confirmation: '',
      collaborator_function_id: '',
      end_date: '',
      organization_id: ''
    })
    const address = ref({})
    const foundPerson = ref(false)
    const errors = ref(null)
    const idLength = [11, 14]

    watch(
        () => form.value.cpf_cnpj,
        (val) => {
          if (!val) {
            form.value = {}
            address.value = {}
            foundPerson.value = false
          }
          if (val && idLength.includes(val.length) && !foundPerson.value) {
            personRepository.findPersonByNameOrCpf({
              data_person: val
            }).then((response) => {
              let data = _.first(response.data)
              if (data) {
                form.value = data
                address.value = data.address
                foundPerson.value = true
              }
            })
          }
        }
    )

    function createCollaborator(value) {
      collaboratorRepository.createCollaborator(value).then((response) => {
        this.$notify('Colaboração adicionada com sucesso', 'success')
        emit('save')
      }).catch((error) => {
         errors.value = error.errors
      })
    }

    function storeCollaborator(value) {
      collaboratorRepository.storeCollaborator(value).then((response) => {
        emit('save')
      }).catch((error) => {
        errors.value = error.errors
      })
    }

    function closeModal() {
      emit('close')
    }

    async function handleCollaborator() {
      try {
        if (foundPerson.value) {
          form.value.person_id = form.value.id
          createCollaborator(form.value)
        } else {
          form.value = {
            ...form.value,
            address: address.value
          }
          storeCollaborator(form.value)
        }

      } catch (e) {

      }

    }

    return {
      form,
      address,
      errors,
      foundPerson,
      handleCollaborator,
      closeModal
    }
  },

}
</script>

<style lang="scss" scoped>

</style>